import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import "antd/dist/antd.min.css";
import "./index.css";
import "./custom-buttons.css";
import "./custom-inputs.css";
import "./custom-tables.css";
import "./custom-tooltips.css";
import "./custom-sidebar.css";
import { message } from "antd";

// Silence console.log/debug/info in production builds so API responses, payloads,
// etc. that get logged during development don't sit in end users' browser consoles.
// console.warn/error are left intact for real error visibility. No-op in dev.
if (process.env.NODE_ENV === "production") {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
}

// Global configuration for Ant Design messages
message.config({
  top: 50,
  duration: 3,
  maxCount: 3,
  rtl: false,
  prefixCls: 'ant-message',
  getContainer: () => document.body,
  zIndex: 100015, // Higher than offcanvas at 100006
});

// import ErrorBoundary from "./ErrorBoundary.jsx";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  //<React.StrictMode>
  <BrowserRouter>
    {/* <ErrorBoundary> */}
    <App />
    {/* </ErrorBoundary> */}
  </BrowserRouter>
  //</React.StrictMode>
);
